



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Assets from '@/constants/assets';

@Component
export default class Avatar extends Vue {
  @Prop() private colorOverlay!: AvatarColorOverlay;
  @Prop() private imageSize!: AvatarSize;
  @Prop() private imageUrl!: string;
  @Prop({ default: '' }) private iconOverlay!: string;
  @Prop({ default: '' }) private textOverlay!: string;
  @Prop({ default: '' }) private textRightOverlay!: string;
  @Prop({ default: false }) private overlayFixed!: boolean;
  @Prop({ default: false }) private withBorder!: boolean;
  @Prop({ default: true }) private isClickable!: boolean;

  private assets = Assets;

  // METHODS
  private avatarClick() {
    if (this.isClickable) {
      this.$emit('avatar-clicked');
    }
  }

  private hasOverlaySlot() {
    return !!this.$slots['overlay'];
  }

  // COMPUTED
  get image() {
    return (this.imageUrl || this.imageUrl === '' ) ? this.imageUrl : this.assets.defaultAvatar;
  }
  private get showOverlay() {
    return this.iconOverlay !== '' || this.textOverlay !== '';
  }
}

export enum AvatarColorOverlay {
  Primary = 'opacity--primary-color',
}

export enum AvatarSize {
  Small = 'avatar--small',
}

